import Vue from 'vue'
import Vuex from 'vuex'

import SignIn from './mutations/signIn';
import SetProfile from './mutations/setProfile';
import SetUserGroups from './mutations/setUserGroups';
import SetCity from './mutations/setCity';
import SetVehicleCategory from './mutations/setVehicleCategory';
import SetVehicleLevel from './mutations/setVehicleLevel';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    profile: null,
    city: [],
    vehicleLevel: [],
    vehicleCategory: [],
    groups: [],
    token: localStorage.getItem('token'),
  },
  mutations: {
    SignIn,
    SetProfile,
    SetUserGroups,
    SetCity,
    SetVehicleCategory,
    SetVehicleLevel
  },
  actions: {},
  modules: {},
  getters: {}
});
